var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsers = function SvgUsers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 16.294a6.561 6.561 0 0 0 2.267-4.96 6.666 6.666 0 1 0-13.334 0 6.56 6.56 0 0 0 2.267 4.96A10.666 10.666 0 0 0 1.334 26 1.333 1.333 0 1 0 4 26a8 8 0 0 1 16 0 1.333 1.333 0 1 0 2.667 0 10.666 10.666 0 0 0-6.267-9.706Zm-4.4-.96a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm12.987.426A6.667 6.667 0 0 0 20 4.667a1.333 1.333 0 1 0 0 2.667 4 4 0 0 1 4 4 4 4 0 0 1-2 3.453 1.334 1.334 0 0 0-.067 2.267l.52.346.174.094A9.333 9.333 0 0 1 27.96 26a1.333 1.333 0 1 0 2.667 0 11.999 11.999 0 0 0-5.64-10.24Z",
    fill: "#fff"
  })));
};
export default SvgUsers;